export default __webpack_public_path__ + "static/media/ep5collage4.b380a955.jpg";